(function ($) {
    'use strict';

    /* ========= Activate mobile search overlay ========= */

    var $mobileSearchButton = $('.js-mobile-search'),
        $searchOverlay = $('.js-search-overlay'),
        $body = $('body'),
        $headerToggle = $('.js-header-toggle button'),
        $headerTabbingElements = $('.js-header-taborder'),
        $navigation = $('.js-navigation');

        $mobileSearchButton.click(function(){

            if(!$mobileSearchButton.hasClass('active')){
                $headerToggle.removeClass('active');
                $navigation.removeClass('active');
                $body.removeClass('navigation-open');
                $headerTabbingElements.find('a, button').removeAttr('tabindex');
                $navigation.find('.active').removeClass('active'); 
                $('html,body,.page-wrapper').addClass('overflow-hide');
                $mobileSearchButton.addClass('active');
                $searchOverlay.addClass('active');
                $searchOverlay.find('input[type="text"]').focus();
                $('.main, .footer').find('a, button').attr('tabindex', '-1');
                $('.header__logo a, .header__toggle button').attr('tabindex', '-1');
            }else {
                $mobileSearchButton.removeClass('active');
                $searchOverlay.removeClass('active');
                $('html,body,.page-wrapper').removeClass('overflow-hide');
                $('.main, .footer').find('a, button').removeAttr('tabindex');
                $('.header__logo a, .header__toggle button').removeAttr('tabindex');
            }

        });

}(jQuery));